import { Box, Button, Card, CardContent, CardHeader, FormControl, FormLabel, Grid, TextField, Typography } from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useUpdUserDataMutation } from "src/redux/api/cabinet";
import { updProfileData } from "src/redux/slices/app";
import { AppState } from "src/store/Store";
import { Alerting } from "src/views/components_cabinet/Alerting";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const WalletsTab = () => {
    const [getAlert, setgetAlert] = useState<{ type: number, msg: string } | undefined>(undefined);
    const { data } = useSelector((state: AppState) => state.app);
    const [payeerWallet, setPayeerWallet] = useState<string>('');
    const [bybitWallet, setBybitWallet] = useState<string>('');
    const [btcWallet, setBtcWallet] = useState<string>('');
    const dispatch = useDispatch();


    useEffect(() => {
        console.log("data");
        console.log(data);
        if (data.wallet) setPayeerWallet(data.wallet);
        if (data.wallet2) setBybitWallet(data.wallet2);
        if (data.wallet_btc) setBtcWallet(data.wallet_btc);
    }, [data])

    const SubmitForm = () => {
        const d = data;

        if (d.wallet && d.wallet2 && d.wallet_btc) {
            setgetAlert({ type: 2, msg: 'Кошельки уже сохранены, изменение возможно только через Админа' });
            return false
        }

        if (!payeerWallet && !bybitWallet && !btcWallet) {
            setgetAlert({ type: 2, msg: 'Укажите хотя бы один кошелёк' });
            return false
        }

        const param: any = {};
        if (!d.wallet && payeerWallet && payeerWallet.length >= 2) {
            param.wallet = payeerWallet;
        }
        if (!d.wallet2 && bybitWallet && bybitWallet.length >= 2) {
            param.wallet2 = bybitWallet;
        }
        if (!d.wallet_btc && btcWallet && btcWallet.length >= 2) {
            param.wallet_btc = btcWallet;
        }

        getRequest(param);
    }

    const [getData, { isLoading }] = useUpdUserDataMutation();
    const getRequest = async (data: any) => {
        const jwt = localStorage.getItem('jwt');
        await getData({ body: data, jwt })
            .unwrap()
            .then((payload: any) => {
                dispatch(updProfileData(payload.data));
                setgetAlert({ type: 1, msg: payload.message });
            })
            .catch((error: any) => {
                setgetAlert({ type: 2, msg: error.data.message });
            })
    }

    return (
        <>
            <Card sx={{ background: 'transparent', boxShadow: 'none', borderColor: 'transparent' }}>
                <CardHeader title="Вывести" />
                <CardContent>
                    <Grid container display='flex' justifyContent='center'>
                        <Grid item xs={12} md={8} display='flex' justifyContent='center'>
                            <Box width='100%' display='flex' flexDirection='column'>
                                <Box mb={3}>
                                    <Typography mb={3} variant="h6">
                                        Кошельки для вывода
                                    </Typography>
                                    <Box
                                        sx={{
                                            backgroundColor: '#fff3e0',
                                            border: '1px solid #ffb74d',
                                            borderRadius: 1,
                                            padding: 1.5,
                                            mb: 2,
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: 1
                                        }}
                                    >
                                        <InfoOutlinedIcon sx={{ color: '#f57c00', fontSize: 24, mt: 0.2 }} />
                                        <Typography variant="caption" sx={{ fontSize: 18, color: '#e65100', lineHeight: 1.5 }}>
                                            Укажите ваш адрес кошелька USDT BEP-20 (комиссия 1%), адрес BTC или ID кошелька ByBit для переводов и выводов без комиссии. Можно указать несколько кошельков.
                                        </Typography>
                                    </Box>
                                </Box>

                                <FormControl sx={{ width: '100%', mb: 3 }}>
                                    <FormLabel sx={{ mb: 1, color: 'text.primary' }}>
                                        Кошелёк USDT BEP-20 (необязательно)
                                    </FormLabel>
                                    <TextField
                                        value={payeerWallet}
                                        size='medium'
                                        id="wallet"
                                        variant="outlined"
                                        disabled={data.wallet ? true : false}
                                        onInput={(el: ChangeEvent<HTMLInputElement>) => setPayeerWallet(el.target.value)}
                                        placeholder="Введите адрес кошелька USDT BEP-20"
                                        multiline
                                        rows={3}
                                    />
                                </FormControl>

                                <FormControl sx={{ width: '100%', mb: 3 }}>
                                    <FormLabel sx={{ mb: 1, color: 'text.primary' }}>
                                        Кошелёк BTC (необязательно)
                                    </FormLabel>
                                    <TextField
                                        value={btcWallet}
                                        size='medium'
                                        id="wallet_btc"
                                        variant="outlined"
                                        disabled={data.wallet_btc ? true : false}
                                        onInput={(el: ChangeEvent<HTMLInputElement>) => setBtcWallet(el.target.value)}
                                        placeholder="Введите адрес кошелька BTC"
                                        multiline
                                        rows={3}
                                    />
                                </FormControl>

                                <FormControl sx={{ width: '100%', mb: 3 }}>
                                    <FormLabel sx={{ mb: 1, color: 'text.primary' }}>
                                        ID ByBit (необязательно)
                                    </FormLabel>
                                    <TextField
                                        value={bybitWallet}
                                        size='medium'
                                        id="wallet2"
                                        variant="outlined"
                                        disabled={data.wallet2 ? true : false}
                                        onInput={(el: ChangeEvent<HTMLInputElement>) => setBybitWallet(el.target.value)}
                                        placeholder="Введите ID кошелька ByBit"
                                        multiline
                                        rows={2}
                                    />
                                </FormControl>

                                {(!data.wallet || !data.wallet2 || !data.wallet_btc) && (
                                    <Button
                                        onClick={() => SubmitForm()}
                                        size="small"
                                        sx={{ maxWidth: { xs: '100%', md: "160px" } }}
                                        variant="contained"
                                        disabled={isLoading}
                                    >
                                        Сохранить
                                    </Button>
                                )}
                                {data.wallet && data.wallet2 && data.wallet_btc && (
                                    <Button
                                        size="small"
                                        sx={{ maxWidth: { xs: '100%', md: "160px" } }}
                                        variant="contained"
                                        disabled
                                    >
                                        Сохранить
                                    </Button>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {getAlert && <Alerting get={getAlert} />}
        </>
    )
}